import React from 'react';
import {
 Shield
} from 'lucide-react';
import PlaceholderPage from '../components/PlaceholderPage';

const SecurityPage: React.FC = () => {
    return (
        <PlaceholderPage
            title="Security"
            icon={Shield}
            description="Manage roles, permissions, and access control for your application."
        />
    );
};

export default SecurityPage;
